

<template>
     <Form :label-width="120" :model="formData"  class="clearfix"  ref="form">
        <Col span="12">
            <FormItem label='Seller SKU:' prop="sellerSku" :rules='required'>
                <span v-if="formData.id">{{formData.sellerSku}}</span>
                <Input v-else v-model="formData.sellerSku"/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem label='发运数量:' prop="shippingNum" :rules='required'>
                <span v-if="formData.id">{{formData.shippingNum}}</span>
                <InputNumber v-else v-model="formData.shippingNum" class="width-100per" :min='1'/>
            </FormItem>
        </Col>
        <Col span="24"></Col>
        <Col span="12">
            <FormItem label='接收数量:' >
                <InputNumber v-model="formData.inboundAmount" class="width-100per" :min='0'/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem label='Disposition:' prop="disposition" :rules='required'>
                <span v-if="formData.id">{{formData.disposition=='Sellable'?'可售库存':'不可售库存'}}</span>
                <Select v-else v-model="formData.disposition">
                    <Option value="Sellable">可售库存</Option>
                    <Option value="Unsellable">不可售库存</Option>
                </Select>
            </FormItem>
        </Col>
        <Col span="24"></Col>
        <Col span="12">
            <FormItem label='Carrier:' prop="carrier" :rules='required'>
                <span v-if="formData.id">{{formData.carrier}}</span>
                <Input v-else v-model="formData.carrier"/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem label='Tracking:' prop="tracking" :rules='required'>
                <span v-if="formData.id">{{formData.tracking}}</span>
                <Input v-else v-model="formData.tracking"/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem label='状态:' prop="shippingType" :rules='required'>
                <span v-if="formData.id">{{formData.shippingType}}</span>
                <Select v-else v-model="formData.shippingType">
                    <Option value="Pending">Pending</Option>
                    <Option value="Completed">Completed</Option>
                </Select>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem label='发货时间:' prop="deliveryAt" :rules='required'>
                <span v-if="formData.id">{{formData.deliveryAt}}</span>
                <DatePicker v-else v-model="formData.deliveryAt" type="datetime" class="width-100per"></DatePicker>
            </FormItem>
        </Col>
        <Col span="24" class="text-center bg-fff padding-15">
            <Button type="primary" class="width-20per" @click="submit">提交</Button>
            <Button class="width-20per" @click="cancel">取消</Button>
        </Col>
    </Form>
</template>

<script>

export default {
    props: ['data'],
    data() {
        return {
            formData: { shippingNum: "", inboundAmount: "", shippingType: "Pending", disposition: "Sellable", ... this.data },
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],
        };
    },
    methods: {
        cancel() {
            this.$emit('on-close')
        },
        async submit() {
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            this.$emit('on-update', { ...this.formData, deliveryAt: this.handleDateFormat(this.formData.deliveryAt, 'yyyy-mm-dd HH:MM:SS') });
            this.cancel();
        },
    },
};
</script>



